import { render, staticRenderFns } from "./EventFestivalChallenge.vue?vue&type=template&id=7aa6acec&"
import script from "./EventFestivalChallenge.vue?vue&type=script&lang=js&"
export * from "./EventFestivalChallenge.vue?vue&type=script&lang=js&"
import style0 from "./EventFestivalChallenge.vue?vue&type=style&index=0&id=7aa6acec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports